import { render, staticRenderFns } from "./SocialSecurity.vue?vue&type=template&id=63a1a954&scoped=true"
import script from "./SocialSecurity.vue?vue&type=script&lang=js"
export * from "./SocialSecurity.vue?vue&type=script&lang=js"
import style0 from "./SocialSecurity.vue?vue&type=style&index=0&id=63a1a954&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a1a954",
  null
  
)

export default component.exports